import { LoaiPhieuNhapEnum } from '@/core/enums/loaiPhieuNhap.enum';
import type { PhieuNhapKhoLoaiPhieu } from './types';

export const PHIEU_NHAP_KHO_LOAI = {
  TAM_NHAP: LoaiPhieuNhapEnum.TAM_NHAP,
  HOP_DONG_MUA_BAN: LoaiPhieuNhapEnum.HOP_DONG_MUA_BAN,
  HOP_DONG_DIEU_CHINH: LoaiPhieuNhapEnum.HOP_DONG_DIEU_CHINH,
} as const satisfies Record<string, PhieuNhapKhoLoaiPhieu>;

export function getChiTietPhieuNhapKhoParams(id: number) {
  return { idPhieuNhapKho: id };
}
